import React, { Component } from "react";
import { translate } from "react-i18next";
import PropTypes from "prop-types";

import { MenuItem } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";

import InputFormat from "../partials/inputForm";
import countryCode from "../utils/countryCode";
const styles = (theme) => ({
  selectMenu: {
    height: "1.1875em",
  },
});
class CountryCode extends Component {
  constructor(props) {
    super(props);
    this.state = {
      country: "",
    };
  }
  handleCountryCode = (name, value) => {
    this.setState({ country: value.code });
    this.props.handleCountryCode(name, value.value);
  };
  render() {
    const {
      classes,
      t,
      code,
      handleCountryCode,
      disabled = false,
      margin,
      showFull = false,
      ...props
    } = this.props;
    let { country } = this.state;

    let find;
    if (code === "+1")
      find = countryCode.find((e) => e.value === code && e.code === country);
    else find = countryCode.find((e) => e.value === code);
    return (
      <InputFormat
        variant="outlined"
        select
        disabled={disabled}
        label={t("countrycode_code")}
        name="type"
        required
        margin={margin}
        value={code || "+84"}
        onChange={(event) =>
          this.handleCountryCode("countryCode", event.target.value)
        }
        SelectProps={{
          renderValue: (value) =>
            !showFull && find ? `${find.emoji} ${find.value} ` : `${value}`,
        }}
        InputProps={{
          className: classes.selectMenu,
          name: "countryCode",
          id: "country-code",
        }}
        InputLabelProps={{
          className: classes.label,
        }}
      >
        {countryCode.map((code, key) => {
          return (
            <MenuItem value={code} key={code.country}>
              {code.emoji} {code.country} {code.value}
            </MenuItem>
          );
        })}
      </InputFormat>
    );
  }
}

CountryCode.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

export default translate("translations")(
  withStyles(styles, { withTheme: true })(CountryCode)
);
